
import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { LoggerService } from '../services/logger.service';
import { environment } from '@environments/environment';

export const responseInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const apiBaseUrl = environment?.api_url ?? '';

  // Only rewrite errors for the customer-management API.
  // Presigned S3 uploads must pass through unchanged (empty/XML bodies, raw status codes).
  const isApiRequest = !!apiBaseUrl && req.url.startsWith(apiBaseUrl);
  if (!isApiRequest) {
    return next(req);
  }

  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse) {
        // Pass through; reserved for future API response transforms.
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred';

      if (error.error instanceof ErrorEvent) {
        errorMessage = `Error: ${error.error.message}`;
      } else {
        if (error.status === 401) {
          errorMessage = 'Unauthorized request. Please log in again.';
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else {
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
      }

      logger.error('[HTTP Interceptor Error]', errorMessage);
      return throwError(() => new Error(errorMessage));
    })
  );
};
